import {message} from "antd";
import {
  TValidateAccountNumberApiResponse,
  TValidateBankAccountPayload,
  useVerifyAccountNumberMutation,
} from "../../../../../../../react-query-hooks/payout";
import {usePayoutSettingsContext} from "../../context";

interface HookResult {
  verifyAccountNumber(values: TValidateBankAccountPayload): void;
  wasAccountNumberVerified: boolean;
  isVerifyingAccountNumber: boolean;
  errorVerifyingAccountNumber: boolean;
  isMutationIdle: boolean;
  responseData?: TValidateAccountNumberApiResponse;
  resetMutation: () => void;
}

export interface UseAccountNumberVerificationOptions {
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}
export const useAccountNumberVerification = (
  options?: UseAccountNumberVerificationOptions
): HookResult => {
  const mutation = useVerifyAccountNumberMutation();
  const {dispatch} = usePayoutSettingsContext();

  function verifyAccountNumber(values: TValidateBankAccountPayload) {
    mutation.mutate(values, {
      onSuccess: (data) => {
        dispatch({
          type: "update-connect-bank-account-name-value",
          payload: data.data.name,
        });
      },
      onError: (error) => {
        message.error(error.message);
        dispatch({
          type: "update-connect-bank-account-name-value",
          payload: null,
        });
      },
    });
  }

  return {
    verifyAccountNumber,
    isVerifyingAccountNumber: mutation.isLoading,
    wasAccountNumberVerified: mutation.isSuccess,
    errorVerifyingAccountNumber: mutation.isError,
    responseData: mutation.isSuccess ? mutation.data.data : undefined,
    resetMutation: mutation.reset,
    isMutationIdle: mutation.isIdle,
  };
};
